(() => {
  'use strict';
  if (window.TFCardHover) return;
  const device = window.matchMedia('(hover:hover) and (pointer:fine)');
  const cache = new Map(), bound = new WeakSet();
  const legacy = '.tfbl-product,.tfbl-product-card,.tf-product-card,.tfhw-card,[data-wish-list]>article';
  function safeProductURL(value) {
    try {
      const url = new URL(value, location.href);
      const match = url.pathname.match(/^(.*\/products\/)([a-z0-9][a-z0-9-]*)\/?$/i);
      if (url.origin !== location.origin || !match) return null;
      url.pathname = match[1] + match[2];
      url.search = ''; url.hash = '';
      return url;
    } catch { return null; }
  }
  function ready(image) {
    if (bound.has(image)) return;
    bound.add(image);
    const overlay = image.closest('.tf-card-hover-overlay');
    const show = () => { if (image.naturalWidth > 0) overlay.classList.add('is-ready'); };
    image.addEventListener('load', show);
    image.addEventListener('error', () => overlay.classList.remove('is-ready'));
    if (image.complete) show();
  }
  function loadData(url) {
    const key = url.pathname;
    if (!cache.has(key)) {
      const request = new URL(url.href);
      request.searchParams.set('section_id', 'tfdawn-card-hover-data');
      cache.set(key, fetch(request.href, { credentials: 'same-origin', signal: AbortSignal.timeout(8000) })
        .then(response => { if (!response.ok) throw Error('Card image unavailable'); return response.text(); })
        .then(html => {
          const payload = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-tf-card-hover-data]');
          if (!payload) return null;
          const value = JSON.parse(payload.textContent);
          return value.handle === key.split('/').pop() ? value.hover : null;
        }).catch(() => null));
    }
    return cache.get(key);
  }
  async function enhance(card) {
    if (card.hasAttribute('data-tf-card-hover')) return;
    const link = [...card.querySelectorAll('a[href]')].map(a => safeProductURL(a.href)).find(Boolean);
    const image = card.querySelector('img:not(.tf-card-hover-image)');
    if (!link || !image) return;
    card.setAttribute('data-tf-card-hover', 'dynamic');
    const source = await loadData(link);
    if (!source || !card.isConnected) return;
    let url;
    try { url = new URL(source, location.href); if (!['http:', 'https:'].includes(url.protocol)) return; } catch { return; }
    let media = image.closest('.tf-card-hover-media');
    if (!media) {
      media = document.createElement('span'); media.className = 'tf-card-hover-media';
      image.before(media); media.append(image);
    }
    const overlay = document.createElement('span'); overlay.className = 'tf-card-hover-overlay'; overlay.setAttribute('aria-hidden', 'true');
    const hover = document.createElement('img'); hover.className = 'tf-card-hover-image'; hover.alt = ''; hover.width = 720; hover.height = 960; hover.loading = 'lazy'; hover.decoding = 'async';
    overlay.append(hover); media.append(overlay); ready(hover); hover.src = url.href;
  }
  const pending = new WeakSet();
  const observer = typeof window.IntersectionObserver === 'function' ? new IntersectionObserver(entries => {
    for (const entry of entries) if (entry.isIntersecting) { observer.unobserve(entry.target); enhance(entry.target); }
  }, { rootMargin: '300px' }) : null;
  function scan(root = document) {
    root.querySelectorAll('.tf-card-hover-image').forEach(ready);
    if (!device.matches) return;
    root.querySelectorAll(legacy).forEach(card => {
      if (pending.has(card) || card.hasAttribute('data-tf-card-hover')) return;
      pending.add(card);
      if (observer) observer.observe(card); else enhance(card);
    });
  }
  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(() => { scheduled = false; scan(); });
  };
  window.TFCardHover = { refresh: schedule };
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', schedule);
  device.addEventListener('change', schedule);
  scan();
})();
